<h1 mat-dialog-title>{{"CHANGE_WEEK.SELECT" | translate}}</h1>
<div mat-dialog-content>
  {{"CHANGE_WEEK.ATTENTION" | translate}}
</div>
<div class="btn-group">
  <button mat-button mat-dialog-close (click)="close()">{{"CHANGE_WEEK.CANCEL" | translate}}</button>
  <button mat-button cdkFocusInitial (click)="changeWeek()">{{"CHANGE_WEEK.SURE2" | translate}}</button>
</div>
